import { FormControl, FormControlLabel, FormHelperText, Grid } from '@material-ui/core';
import { FormikErrors, FormikHandlers, FormikHelpers, getIn } from 'formik';
import React from 'react';
import Label from '../../../../common/components/label';
import { ISi } from '../../../../common/dtos/SiDto';
import { WrittenVerbalBothCodes_class } from '../../../../common/enums/WrittenVerbalBothCodes';
import { IndentGrid, MHARadio } from '../../../../common/styles/styles';

interface Props {
  label: string;
  name: string;
  value: number | undefined;
  errors: FormikErrors<ISi>;
  handleBlur: FormikHandlers["handleBlur"];
  setFieldValue: FormikHelpers<ISi>["setFieldValue"];
  isReadOnly: boolean;
}

const WrittenVerbalBothCodeField: React.FC<Props> = ({ label, name, value, errors, handleBlur, setFieldValue, isReadOnly }) => {

  return (
    <>
      <Grid item xs={12}>
        <Label>{label}</Label>
      </Grid>
      <IndentGrid container direction="row">
        <FormControl error={Boolean(getIn(errors, name))} >
          <IndentGrid container direction="row">
            <FormControlLabel
              checked={value === WrittenVerbalBothCodes_class.enum.W}
              value={value}
              data-cy={`sidesResponse_${name}_Written`}
              onChange={() => setFieldValue(name, WrittenVerbalBothCodes_class.enum.W)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} size="small" name={name} />}
              label="Written" />
            <FormControlLabel
              checked={value === WrittenVerbalBothCodes_class.enum.V}
              value={value}
              data-cy={`sidesResponse_${name}_401K`}
              onChange={() => setFieldValue(name, WrittenVerbalBothCodes_class.enum.V)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} name={name} size="small" />}
              label="Verbal" />
            <FormControlLabel
              checked={value === WrittenVerbalBothCodes_class.enum.B}
              value={value}
              data-cy={`sidesResponse_${name}_401K`}
              onChange={() => setFieldValue(name, WrittenVerbalBothCodes_class.enum.B)}
              onBlur={handleBlur}
              control={<MHARadio disabled={isReadOnly} name={name} size="small" />}
              label="Both" />
            {/*<FormControlLabel*/}
            {/*  checked={value === undefined}*/}
            {/*  value={value}*/}
            {/*  data-cy={`sidesResponse_${name}_undefined`}*/}
            {/*  onChange={() => setFieldValue(name, undefined)}*/}
            {/*  onBlur={handleBlur}*/}
            {/*  control={<MHARadio disabled={isReadOnly} name={name} size="small" />}*/}
            {/*  label="N/A" />*/}
          </IndentGrid>
          {Boolean(getIn(errors, name)) &&
            <FormHelperText
            id={`${name}-helper_text`}
          >
              {getIn(errors, name)}
            </FormHelperText>
          }
        </FormControl>
      </IndentGrid>
    </>
  );

}

export default WrittenVerbalBothCodeField;